import Link from "ds/components/Link";
import useAnalytics from "hooks/useAnalytics";
import { RunIgnoredTrigger, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";
import { providerHasVcsHost } from "utils/vcs";

type StackRunsIgnoredRunCalloutCommitLinkProps = {
  ignoredRun: RunIgnoredTrigger;
  vcsProvider: VcsProvider;
};
const StackRunsIgnoredRunCalloutCommitLink = ({
  ignoredRun,
  vcsProvider,
}: StackRunsIgnoredRunCalloutCommitLinkProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics();

  const handlePress = () => {
    trackSegmentAnalyticsEvent("Ignored run warning commit link clicked");
  };

  // A provider without a VCS host has no commit page to link to.
  if (!providerHasVcsHost(vcsProvider)) {
    return <>{getCommitLabel(vcsProvider, ignoredRun.commit.hash)}</>;
  }

  return (
    <Link
      variant="secondary"
      size="inherit"
      onPress={handlePress}
      href={ignoredRun.commit.url}
      rel="noopener noreferrer"
      target="_blank"
    >
      {getCommitLabel(vcsProvider, ignoredRun.commit.hash)}
    </Link>
  );
};

export default StackRunsIgnoredRunCalloutCommitLink;
